import { render, staticRenderFns } from "./LineCard.vue?vue&type=template&id=b82fd81e&scoped=true&"
import script from "./LineCard.vue?vue&type=script&lang=js&"
export * from "./LineCard.vue?vue&type=script&lang=js&"
import style0 from "./LineCard.vue?vue&type=style&index=0&id=b82fd81e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82fd81e",
  null
  
)

export default component.exports